<template>
  <div>

    <SummaryHead summaryClass="-relationship">
      <template v-slot:title01>{{pagetitle}}</template>
      <template v-slot:txt>
        人が人に接するコミュニケーションには特徴があります。営業にもいろんなタイプの方がいますよね。<br>
        個々人ごとに異なるコミュニケーションの特徴ですが、属する集団により一定の傾向が見られるようです。<br>
        企業の求める人物像や組織風土が影響しているものと考えられますが、企業の枠を飛び越え、業界ごとに比べたときにはどうでしょうか？<br>
        今回は業界ごとに対人コミュニケーションの傾向について比較してみました。<br>
        別の記事では意思決定の傾向についても比較しているので合わせてご覧ください。
      </template>
    </SummaryHead>    
    <div class="contents-block">

    <section class="summary-section">

      <fade-in-component>
        <h2 class="ttlbar -pink _mw1000">対人関係の傾向を分類</h2>
      </fade-in-component>

      <fade-in-component>
      <div class="sminner">

        <p class="txt _txtC _mb60">
          対人関係の傾向をこの図のように分類しました。
        </p>

        <ScatterArea scaType="relationship"></ScatterArea>
        
      </div><!-- .sminner -->
        </fade-in-component> 

      <fade-in-component>
        <div class="relation-block01">
          <div class="block-two -bptablet">
            <div class="block">
              <h3 class="smttlm -pink _trgbtmct">縦軸では、社交性の程度からコミュニケーションの<br class="_revpc">スタイルが慎重なのか大胆なのかを測ります。</h3>
              <dl class="relationdl">
                <dt class="rdt">慎重なタイプ</dt>
                <dd class="_mb15">自分よりも相手発信のコミュニケーションに身を委ねる傾向があります。</dd>
                <dt class="rdt">大胆なタイプ</dt>
                <dd>社交的であり自ら積極的にコミュニケーションを取りにいきます。</dd>
              </dl>
            </div>
            <div class="block">
              <h3 class="smttlm -pink _trgbtmct">横軸では、自分と相手のどちらを<br>優先する傾向があるか測ります。</h3>
              <dl class="relationdl">
                <dt class="rdt">献身的な傾向が強い場合</dt>
                <dd class="_mb15">自分より相手を優先し協調性に長けますが、ときに自己発信力がないと思われることもあります。</dd>
                <dt class="rdt">好戦的な傾向が強い場合</dt>
                <dd>自分の意見を明確に伝えられますが、過剰になると否定的な人という印象を与えかねません。</dd>
              </dl>
              
            </div>
          </div><!-- .block-two -->
        </div><!-- .relation-block01 -->
      </fade-in-component>

      <div class="relation-block02">
        <fade-in-component>
          <h3 class="ttlrb02"><span class="ttlin">上記をもとに対人関係の傾向を</span><span class="ttlin">4象限に分類しました。</span><span class="ttlin">該当する業界と一緒に紹介していきます。</span></h3>
          <div class="rb02inner">
            <div class="rb02block">
              <h4 class="ttlrb02m -t01">主張する</h4>
              <p class="rb02txt">
                好戦的かつ大胆なこのタイプは、自分の意見に周囲が感化、納得するようにコミュニケーションすることに長けているタイプです。主張が速く強い場合があるため、相手が優柔不断なタイプの場合、頼もしいか強引かで印象がわかれやすい傾向があります。<br>
                該当する業界は不動産でした。<br>
                選択肢が豊富であったり、高額な物件を検討する顧客の意思決定を後押しするような押しの強さがイメージされます。
              </p>
            </div><!-- .rb02block -->
            <div class="rb02block">
              <h4 class="ttlrb02m -t02">引き出す</h4>
              <p class="rb02txt">
                献身的でありながら大胆なこのタイプは、相手を感化し意見を引き出すタイプです自己主張をしつつも受容性が高いため、相手の意見を肯定しながら対話を進めていきます。<br>
                業界では、銀行、商社、証券、食品メーカーが該当しました。<br>
                銀行、証券は若干の傾向がある程度でほぼフラットに近いようです。顕著に特徴がみられたのは食品メーカーです。個別仕入れ先の状況を親身に理解しながらも月ごとに新商品が展開される競合に負けじと自社製品をＰＲし、販促企画の取り仕切りまでおこなうコミュニケーションの活発さがイメージされます。
              </p>
            </div><!-- .rb02block -->
            <div class="rb02block">
              <h4 class="ttlrb02m -t03">教える</h4>
              <p class="rb02txt">
                好戦的かつ慎重なこのタイプは、相手の意見を是々非々で一刀両断するようなタイプです。自分から意見を発信するよりも、求められれば積極的に対話する傾向があります。<br>
                該当する業界はITでした。顧客の課題に対し、知識や技術的な専門性をもって解決策を提示する姿がイメージされます。
              </p>
            </div><!-- .rb02block -->
            <div class="rb02block">
              <h4 class="ttlrb02m -t04">受け止める</h4>
              <p class="rb02txt">
                献身的かつ慎重なこのタイプは、相手の思いをくみ取るタイプです。<br>
                みずから積極的に発信することはやや苦手な傾向がありながら、相手とは調和し良き対話相手となります。<br>
                業界では製薬（ＭＲ）、保険、人材、自動車ディーラーが該当しました。なかでも顕著に傾向が表れたのは製薬（ＭＲ）と保険です。<br>
                製薬(MR)には、多忙なドクターに合わせた行動とコミュニケーションが求められる姿が、また、保険には顧客の要望を引き出しながら、適切にプラン設計を促す姿がイメージされます。
              </p>
            </div><!-- .rb02block -->

          </div><!-- .rb02inner -->
        </fade-in-component>
      </div><!-- .relation-block02 -->


      <SummaryBottom :bgColor="4">
        <template v-slot:summary>
          <p class="smtxt">
            以上ここまでが業界ごとに対人関係の傾向を比較した結果となります。<br>
            本来個々人によって異なる特性も、属する組織や集団によって一定の傾向がみられます。<br>
            今回は業界という大きなくくりで営業職の方の傾向を調査してみましたが、<br>
            あなたの会社や部署ではどうでしょう？気になる方は是非お問合せください。
          </p>          
        </template>          
      </SummaryBottom>

    </section>

    <RelatedContents :contentsNum="4"></RelatedContents>

  </div><!-- contents-block -->
 </div>

</template>

<script>
import SummaryHead from "../components/SummaryHead.vue";
import SummaryBottom from "../components/SummaryBottom.vue";
import ScatterArea from "../components/ScatterArea.vue";

import RelatedContents from "../components/RelatedContents.vue";
import FadeInComponent from "../components/FadeInComponent.vue";

export default {
  components: {
    RelatedContents,
    SummaryHead,
    SummaryBottom,
    ScatterArea,
    FadeInComponent
  },
  data() {
    return {
      pagetitle:"対人関係に見られる特徴",
    };
  },
  metaInfo: {
    title: "対人関係に見られる特徴 | 人気10業界！営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },  
  },  
  mounted: function(){
    document.querySelector("meta[name='description']").setAttribute('content', "業界ごとに対人関係の傾向を分類。人が人に接するコミュニケーションには特徴があります。営業にもいろんなタイプの方がいますよね。個々人ごとに異なるコミュニケーションの特徴ですが、属する集団により一定の傾向が見られるようです。企業の求める人物像や組織風土が影響しているものと考えられますが、企業の枠を飛び越え、業界ごとに比べたときにはどうでしょうか？今回は業界ごとに対人コミュニケーションの傾向について比較してみました。");
  }  

};
</script>